import { useEffect, useState } from 'react';
import { useWallet } from '../context/WalletContext';
import { useContracts } from './useContracts';

// Privileged if wallet is owner/admin on any of: PlanAdmin, PlanLogic, Storage,
// OR is the configured payoutWallet on Storage (so they can approve GRX).
export const useAdminRole = () => {
  const { account } = useWallet();
  const c = useContracts();
  const [state, setState] = useState({
    loading: true,
    isOwner: false,
    isAdmin: false,
    isPayoutWallet: false,
    isPrivileged: false,
    logicOwner: null, logicAdminCt: null,
    storageOwner: null, storageAdmin: null,
    adminOwner: null, adminAdmin: null,
    payoutWallet: null,
  });

  useEffect(() => {
    let mounted = true;
    (async () => {
      if (!account) {
        if (mounted) setState((s) => ({ ...s, loading: false, isOwner: false, isAdmin: false, isPrivileged: false }));
        return;
      }
      try {
        const [lo, adminCt, so, sa, ao, aa, pw] = await Promise.all([
          c.read.logic.owner().catch(() => null),
          c.read.logic.adminContract().catch(() => null),
          c.read.store.owner().catch(() => null),
          c.read.store.admin().catch(() => null),
          c.read.admin ? c.read.admin.owner().catch(() => null) : Promise.resolve(null),
          c.read.admin ? c.read.admin.admin().catch(() => null) : Promise.resolve(null),
          c.read.store.payoutWallet().catch(() => null),
        ]);
        const me = (account || '').toLowerCase();
        const eq = (x) => x && String(x).toLowerCase() === me;
        const isOwner = eq(lo) || eq(so) || eq(ao);
        const isAdmin = eq(sa) || eq(aa);
        const isPayoutWallet = eq(pw);
        if (!mounted) return;
        setState({
          loading: false,
          isOwner,
          isAdmin,
          isPayoutWallet,
          isPrivileged: isOwner || isAdmin || isPayoutWallet,
          logicOwner: lo, logicAdminCt: adminCt,
          storageOwner: so, storageAdmin: sa,
          adminOwner: ao, adminAdmin: aa,
          payoutWallet: pw,
        });
      } catch {
        if (mounted) setState((s) => ({ ...s, loading: false }));
      }
    })();
    return () => { mounted = false; };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [account]);

  return state;
};
